import ComponentTab from "./componentTab.container";

export default ComponentTab;
